import axios from "axios";
import { RegisterParam } from "./types/RegisterParam";
import { GetByIdParam } from "./types/GetByIdParam";
import { TaxaDTO } from "./types/TaxaDTO";
import { IdGuidParam } from "./types/IdGuidParam";
import { SendMessageParam } from "./types/SendMessageParam";
import { SearchParam } from "./types/SearchParam";
import { SearchResultDTO } from "./types/SearchResultDTO";
import { LookupInfo } from "./types/LookupInfo";
import { OekosystemModel } from "./types/OekosystemModel";
import { SearchDetailsParam } from "./types/SearchDetailsParam";
import { FundDetailsDTO } from "./types/FundDetailsDTO";
import { FundOrtModel } from "./types/FundOrtModel";
import { GemeindeModel } from "./types/GemeindeModel";
import { HerbariumModel } from "./types/HerbariumModel";
import { HerbariumPrivatModel } from "./types/HerbariumPrivatModel";
import { SubstrateModel } from "./types/SubstrateModel";
import { DatenquelleModel } from "./types/DatenquelleModel";
import { ToExcelParams } from "./types/ToExcelParams";
import { ElevationLocation } from "./types/ElevationLocation";
import { ElevationResult } from "./types/ElevationResult";
import { LandModel } from "./types/LandModel";
import { correctDates } from "./helper";

declare var _root_url: string;
function mapUrl(url: string) {
    return _root_url + url;
}

export abstract class PublicController {

  public static async Register(p: RegisterParam): Promise<any> {
    const result = await axios.post(mapUrl("Public/Register"), p);
    return correctDates(result.data);
  }

  public static async GetTaxon(p: GetByIdParam): Promise<TaxaDTO> {
    const result = await axios.post(mapUrl("Public/GetTaxon"), p);
    return correctDates(result.data);
  }

  public static async GetCopyright(p: IdGuidParam): Promise<string> {
    const result = await axios.post(mapUrl("Public/GetCopyright"), p);
    return correctDates(result.data);
  }

  public static async SendMessage(p: SendMessageParam): Promise<any> {
    const result = await axios.post(mapUrl("Public/SendMessage"), p);
    return correctDates(result.data);
  }

  public static async Search(p: SearchParam): Promise<SearchResultDTO[]> {
    const result = await axios.post(mapUrl("Public/Search"), p);
    return correctDates(result.data);
  }

  public static async GetUploader(p: IdGuidParam): Promise<string> {
    const result = await axios.post(mapUrl("Public/GetUploader"), p);
    return correctDates(result.data);
  }

  public static async GetFilterValues(): Promise<LookupInfo> {
    const result = await axios.post(mapUrl("Public/GetFilterValues"), );
    return correctDates(result.data);
  }

  public static async GetOekosysteme(): Promise<OekosystemModel[]> {
    const result = await axios.post(mapUrl("Public/GetOekosysteme"), );
    return correctDates(result.data);
  }

  public static async SearchDetails(p: SearchDetailsParam): Promise<FundDetailsDTO[]> {
    const result = await axios.post(mapUrl("Public/SearchDetails"), p);
    return correctDates(result.data);
  }

  public static async GetFunde(p: GetByIdParam): Promise<FundDetailsDTO[]> {
    const result = await axios.post(mapUrl("Public/GetFunde"), p);
    return correctDates(result.data);
  }

  public static async GetUsers(): Promise<any> {
    const result = await axios.post(mapUrl("Public/GetUsers"), );
    return correctDates(result.data);
  }

  public static async GetFund(p: GetByIdParam): Promise<FundDetailsDTO> {
    const result = await axios.post(mapUrl("Public/GetFund"), p);
    return correctDates(result.data);
  }

  public static async GetFundOrt(p: GetByIdParam): Promise<FundOrtModel> {
    const result = await axios.post(mapUrl("Public/GetFundOrt"), p);
    return correctDates(result.data);
  }

  public static async GetGemeinden(): Promise<GemeindeModel[]> {
    const result = await axios.post(mapUrl("Public/GetGemeinden"), );
    return correctDates(result.data);
  }

  public static async GetHerbarien(): Promise<HerbariumModel[]> {
    const result = await axios.post(mapUrl("Public/GetHerbarien"), );
    return correctDates(result.data);
  }

  public static async GetHerbarienPrivat(): Promise<HerbariumPrivatModel[]> {
    const result = await axios.post(mapUrl("Public/GetHerbarienPrivat"), );
    return correctDates(result.data);
  }

  public static async GetSubstrate(): Promise<SubstrateModel[]> {
    const result = await axios.post(mapUrl("Public/GetSubstrate"), );
    return correctDates(result.data);
  }

  public static async GetDatenquellen(): Promise<DatenquelleModel[]> {
    const result = await axios.post(mapUrl("Public/GetDatenquellen"), );
    return correctDates(result.data);
  }

  public static async ToExcel(p: ToExcelParams): Promise<string> {
    const result = await axios.post(mapUrl("Public/ToExcel"), p);
    return correctDates(result.data);
  }

  public static async GetElevationToLocation(location: ElevationLocation): Promise<ElevationResult> {
    const result = await axios.post(mapUrl("Public/GetElevationToLocation"), location);
    return correctDates(result.data);
  }

  public static async GetAllLaender(): Promise<LandModel[]> {
    const result = await axios.post(mapUrl("Public/GetAllLaender"), );
    return correctDates(result.data);
  }

}
